/* eslint-disable camelcase */
import { clevertapEvent } from 'utils/clevertap';

export const STREAM_VIEW = {
  trending: {
    key: 'trending',
    label: 'Trending',
    arg: 'trending',
  },
  following: {
    key: 'following',
    label: 'Followed',
    arg: 'all watchlist',
  },
  latest: {
    key: 'latest',
    label: 'All',
    arg: 'latest',
  },
  following_people: {
    key: 'following_people',
    label: 'People',
    arg: 'people watchlist',
  },
  following_company: {
    key: 'following_company',
    label: 'Watchlist',
    arg: 'company watchlist',
  },
};

export const PAGE_SOURCE = {
  STREAM: 'Stream',
  PROFILE: 'Profile',
  COMPANY: 'Company',
  LIKES: 'Likes',
  STREAM_HOME: 'Stream Home',
  COMPANY_VIEW: 'Company View',
  COMPANY_PAGE: 'Company Page',
};

const transformPageSource = (pageSource) => {
  switch (pageSource) {
    case 'Profile':
      return PAGE_SOURCE.PROFILE;
    case 'Company':
      return PAGE_SOURCE.COMPANY_VIEW;
    default:
      return PAGE_SOURCE.STREAM_HOME;
  }
};

const transformExtendStream = (pageSource) => {
  if (pageSource === 'Stream') {
    return PAGE_SOURCE.STREAM;
  }
  return transformPageSource(pageSource);
};

const transformExtendLikes = (pageSource) => {
  if (pageSource === 'Likes') {
    return PAGE_SOURCE.LIKES;
  }
  if (pageSource === 'Company') {
    return PAGE_SOURCE.COMPANY_PAGE;
  }
  return transformPageSource(pageSource);
};

const transformGetPostType = (defaultValue, props) => {
  const { polling, target_price, isnews: isNews, reposted } = props;
  const isPolling = Array.isArray(polling) && (polling.length > 0);
  const isPrediction = Array.isArray(target_price) && (target_price.length > 0);

  let postType = defaultValue;

  if (isPolling) {
    postType = 'Polling';
  } else if (isPrediction) {
    postType = 'Prediction';
  } else if (isNews) {
    postType = 'News';
  }

  if (reposted) {
    postType = 'Repost';
  }

  return postType;
};

const transformPostLink = (postId) =>
  // return `${window && window.location && window.location.origin}/post/${postId}`;
  `${postId}`;
const EVENTS = {
  // common
  streamTabViewed: 'Stream View',
  streamPostViewed: 'Stream Post Viewed',
  likeList: 'Stream Likes List',
  postLike: 'Stream Post Liked',
  likesViewed: 'Stream Likes Viewed',
  postFollow: 'Stream User Followed',
  viewProfile: 'Stream View Profile',

  // share
  sharePost: 'Stream Share Post',
  sharePostViewed: 'Stream Share Post Viewed',
  shareMedia: 'Stream Post Shared',
  shareMoreSelected: 'Stream Share More Selected',
  shareMoreViewed: 'Stream Share More Viewed',
  shareCopyLink: 'Stream Copy Link Post Selected',
  shareCopyLinkViewed: 'Stream Link Post Copied',
  shareRepostSelected: 'Stream Repost Stream',
  shareRepostViewed: 'Stream Repost Viewed',
  shareRepostCanceled: 'Stream Post Canceled',
  shareRepostSend: 'Stream Reposted',
  shareSearch: 'Stream Search User Filled',
  shareSearchViewed: 'Stream Search User Result Viewed',

  // tipping
  tipButtonClicked: 'Stream Tip Post',
  tipModalViewed: 'Stream Tip Viewed',
  tipAmountFilled: 'Stream Tip Amount Selected',
  tipMessageFilled: 'Stream Message Filled',
  tipSubmitted: 'Stream Tip Submitted',

  // comments
  commentClicked: 'Stream Comment',
  commentViewed: 'Stream Comments Viewed',
  commentFilled: 'Stream Comment Filled',
  commentSubmitted: 'Stream Comment Submitted',

  // ideas
  ideasViewed: 'Ideas Viewed',

  // reports
  reportsViewed: 'Reports Viewed',
  reportsClicked: 'Reports Clicked',
  reportsOpened: 'Reports Detail Opened',
  reportCompanyClicked: 'Report Company Selected',
  reportDownloaded: 'Report Downloaded',

  // predictions
  predictionsViewed: 'Predictions Viewed',
  predictionsVoted: 'Predictions Voted',
  predictionsBuySelected: 'Predictions Buy Stock Selected',

  // insiders
  insidersViewed: 'Insiders Viewed',

  // charts
  chartsViewed: 'Chart Viewed',
  chartImageClicked: 'Chart Image Opened',
  chartImageViewed: 'Chart Image Viewed',
};

const getLastStreamView = () => localStorage.getItem('stbx-active-stream');

const getLastStreamViewFilter = () => localStorage.getItem('stbx-active-stream-filter');

const StreamTabAnalytics = {
  common: {
    View: {
      onStreamViewed: () => {
        clevertapEvent(EVENTS.streamTabViewed);
      },
      onPostViewed: ({
        pageSource,
        username,
        likes,
        comment,
        postid,
        polling,
        target_price,
        isnews,
        reposted,
      }) => {
        const activeFilter = getLastStreamView();
        const activeTab = getLastStreamViewFilter();
        const page = transformExtendStream(pageSource);
        const streamFilter = ((page === PAGE_SOURCE.STREAM) && (activeTab === 'ideas')) ? STREAM_VIEW[activeFilter].label : 'All';

        const sendData = {
          'Stream Filter': streamFilter,
          'Page Source': page,
          Username: username,
          Likes: likes,
          Comments: Number(comment) !== undefined ? Number(comment) : comment,
          'Stream ID': transformPostLink(postid),
          'Post Type': transformGetPostType('Ideas', {
            polling,
            target_price,
            isnews,
            reposted,
          }),
        };
        clevertapEvent(EVENTS.streamPostViewed, sendData);
      },
      onLikesViewed: () => {
        clevertapEvent(EVENTS.likesViewed);
      },
      onShareModalViewed: () => {
        clevertapEvent(EVENTS.sharePostViewed);
      },
      onTabChanged: (tabName) => {
        if (tabName === 'Polling') {
          return;
        }
        clevertapEvent(`${tabName} Menu Selected`);
      },
      onLoadMore: (tabName) => {
        clevertapEvent(`${tabName} Load More`);
      },
    },
    Action: {
      clickLikeInscription: () => {
        clevertapEvent(EVENTS.likeList);
      },
      clickLikeButton: (pageSource) => {
        clevertapEvent(EVENTS.postLike, {
          'Page Source': transformPageSource(pageSource),
        });
      },
      clickFollowButton: (pageSource) => {
        clevertapEvent(EVENTS.postFollow, {
          'Page Source': transformExtendLikes(pageSource),
        });
      },
      clickProfile: (pageSource) => {
        clevertapEvent(EVENTS.viewProfile, {
          'Page Source': transformExtendLikes(pageSource),
        });
      },
      clickShareButton: (pageSource) => {
        clevertapEvent(EVENTS.sharePost, {
          'Page Source': transformPageSource(pageSource),
        });
      },
      selectShareMedia: ({
        media,
        pageSource,
        postid,
        polling,
        target_price,
        isnews,
        reposted,
      }) => {
        const sendData = {
          Media: media,
          'Page Source': transformPageSource(pageSource),
          'Stream ID': transformPostLink(postid),
          'Post Type': transformGetPostType('Normal', {
            polling,
            target_price,
            isnews,
            reposted,
          }),
        };
        clevertapEvent(EVENTS.shareMedia, sendData);
      },
      clickMoreShare: () => {
        clevertapEvent(EVENTS.shareMoreSelected);
        clevertapEvent(EVENTS.shareMoreViewed);
      },
      selectCopyLink: ({
        pageSource,
        username,
        postid,
        polling,
        target_price,
        isnews,
        reposted,
      }) => {
        const sendData = {
          'Page Source': transformPageSource(pageSource),
          Username: username,
          'Post Type': transformGetPostType('Normal', {
            polling,
            target_price,
            isnews,
            reposted,
          }),
          'Stream ID': transformPostLink(postid),
        };

        clevertapEvent(EVENTS.shareCopyLink, sendData);
        clevertapEvent(EVENTS.shareCopyLinkViewed);
      },
      selectRepost: () => {
        clevertapEvent(EVENTS.shareRepostSelected);
        clevertapEvent(EVENTS.shareRepostViewed);
      },
      selectCancelRepost: () => {
        clevertapEvent(EVENTS.shareRepostCanceled);
      },
      selectSendRepost: ({
        pageSource,
        postid,
        polling,
        target_price,
        isnews,
        reposted,
      }) => {
        const sendData = {
          'Page Source': transformPageSource(pageSource),
          'Post Type': transformGetPostType('Normal', {
            polling,
            target_price,
            isnews,
            reposted,
          }),
          'Stream ID': transformPostLink(postid),
        };

        clevertapEvent(EVENTS.shareRepostSend, sendData);
      },
      selectSearch: () => {
        clevertapEvent(EVENTS.shareSearch);
      },
      selectSearchResult: () => {
        clevertapEvent(EVENTS.shareSearchViewed);
      },
      clickTipping: ({ pageSource, streamId, userId }) => {
        clevertapEvent(EVENTS.tipButtonClicked, {
          'Page Source': transformPageSource(pageSource),
          'Stream ID': transformPostLink(streamId),
          'Recipient User id': transformPostLink(userId),
        });
        clevertapEvent(EVENTS.tipModalViewed, {
          'Stream ID': transformPostLink(streamId),
          'Recipient User id': transformPostLink(userId),
        });
      },
      clickTippingAmount: ({ streamId, userId }) => {
        clevertapEvent(EVENTS.tipAmountFilled, {
          'Stream ID': transformPostLink(streamId),
          'Recipient User id': transformPostLink(userId),
        });
      },
      changeTippingMessage: () => {
        clevertapEvent(EVENTS.tipMessageFilled);
      },
      clickSubmitTip: ({
        pageSource,
        amount,
        message,
        postid,
        username,
        userId,
      }) => {
        const sendData = {
          'Page Source': transformPageSource(pageSource),
          Amount: amount,
          Message: message,
          'Stream ID': transformPostLink(postid),
          Username: username,
          'Recipient User id': transformPostLink(userId),
        };
        clevertapEvent(EVENTS.tipSubmitted, sendData);
      },
      clickComment: ({
        pageSource,
        username,
        postid,
        likes,
      }) => {
        clevertapEvent(EVENTS.commentClicked, {
          'Page Source': transformExtendStream(pageSource),
        });

        const viewData = {
          'Page Source': transformPageSource(pageSource),
          Username: username,
          Likes: likes,
          'Stream ID': transformPostLink(postid),
        };

        clevertapEvent(EVENTS.commentViewed, viewData);
      },
      changeComment: () => {
        clevertapEvent(EVENTS.commentFilled);
      },
      clickSubmitComment: (
        pageSource,
      ) => {
        clevertapEvent(EVENTS.commentSubmitted, {
          'Page Source': transformPageSource(pageSource),
        });
      },
    },
  },
  ideas: {
    View: {
      onIdeasViewed: (filter) => {
        clevertapEvent(EVENTS.ideasViewed, {
          Filter: filter,
        });
      },
    },
  },
  reports: {
    View: {
      onReportsViewed: (filter) => {
        clevertapEvent(EVENTS.reportsViewed, {
          Filter: filter,
        });
      },
    },
    Action: {
      onReportClicked: ({ postid, title }) => {
        clevertapEvent(EVENTS.reportsClicked, {
          'Stream ID': transformPostLink(postid),
          'Reports Name': title,
        });
      },
      onReportOpened: ({ postid, title }) => {
        clevertapEvent(EVENTS.reportsOpened, {
          'Stream ID': transformPostLink(postid),
          'Reports Name': title,
        });
      },
      onReportCompanyClicked: ({ symbol }) => {
        clevertapEvent(EVENTS.reportCompanyClicked, {
          Stock: symbol,
        });
      },
      onReportDownloaded: ({ fileName }) => {
        clevertapEvent(EVENTS.reportDownloaded, {
          'File Name': fileName,
        });
      },
    },
  },
  predictions: {
    View: {
      onPredictionsViewed: () => {
        clevertapEvent(EVENTS.predictionsViewed);
      },
    },
    Action: {
      onPredictionVoted: ({
        vote,
        symbol,
        targetPrice,
        initialPrice,
        upside,
        timing,
        postid,
      }) => {
        clevertapEvent(EVENTS.predictionsVoted, {
          Vote: vote,
          Symbol: symbol,
          'Target Price': targetPrice,
          'Initial Price': initialPrice,
          Upside: upside,
          Timing: timing,
          'Stream ID': transformPostLink(postid),
        });
      },
      onPredictionBuy: ({
        postid,
        symbol,
      }) => {
        clevertapEvent(EVENTS.predictionsBuySelected, {
          'Stream ID': transformPostLink(postid),
          Symbol: symbol,
        });
      },
    },
  },
  insiders: {
    View: {
      onInsidersViewed: () => {
        clevertapEvent(EVENTS.insidersViewed);
      },
    },
  },
  charts: {
    View: {
      onChartsViewed: () => {
        clevertapEvent(EVENTS.chartsViewed);
      },
    },
    Action: {
      onChartsImageClicked: (postid) => {
        clevertapEvent(EVENTS.chartImageClicked, {
          'Stream ID': transformPostLink(postid),
        });

        clevertapEvent(EVENTS.chartImageViewed, {
          'Stream ID': transformPostLink(postid),
        });
      },
    },
  },
};

export default StreamTabAnalytics;
